import React, { useEffect } from "react";
import './index.css';
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/modal";
import { IoMdClose } from "react-icons/io";
import FormPost from "../../components/FormPost";
import { clearStatePost, hideModalPost, setAllPost, setNewPost, showModalPost } from "./redux/actions";
import ButtonSelector from "../../components/ButtonSelector";
import axios from "axios";
import ListSearchPlayerPost from "./components/ListSearchPlayerPost";

const SearchPlayerScreen = ()=>{
    const dispatch = useDispatch()
    const showModal = useSelector(state => state?.searchPlayer?.showModal)
    const newPost = useSelector(state => state?.searchPlayer?.newPost)

    useEffect(()=>{
        const url = 'https://web-production-58ed.up.railway.app/api//get/allSearchPlayerPost'
        axios.get(url).then(res =>{
            dispatch(setAllPost(res?.data?.publicaciones))
        })

    },[newPost?._id])
    useEffect(()=>{

        return ()=>{
            dispatch(clearStatePost())
        }

    },[])
    const handleUpdateStore = data =>{
        dispatch(setNewPost(data?.publicacion))
        dispatch(hideModalPost())

    }
    const renderModal = ()=>(
        <>
        {showModal && (<Modal> 
            <FormPost text={'Ingresa todos los detalles si buscas jugadores o un equipo, puedes escriber el torneo, el campo...'} handleUpdateStore={handleUpdateStore} typePost={'searchPlayer'}  />
            <div className="modal-screen-button-close" onClick={()=> dispatch(hideModalPost())} >
                <IoMdClose style={{width:'40px', height:'40px'}} />

            </div>
        </Modal>)}
        </>
    )
    return(
        <div>
            {renderModal()}
            <div className="search-player-selector-section">
            <ButtonSelector handleShowModal={()=> dispatch(showModalPost())} title={'Crea una publicación para buscar un jugador o un equipo de futbol'} />
            </div>
            <ListSearchPlayerPost />

        </div>

    )
}

export default SearchPlayerScreen